import React, { useEffect, useRef, useState } from "react";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ReplayIcon from "@mui/icons-material/Replay";
import AddIcon from "@mui/icons-material/Add";
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import style from "./kanbanCard.module.css";
import attendantApi from "@/services/api/attendant";
import styleGrid from "@/pages/leads/DataGrid/DataGrid.module.css";
import { Avatar, Box, Typography, IconButton, Menu, MenuItem, CircularProgress} from "@mui/material";
import { Atendente, DetalhesModal } from "@/pages/leads/DetalhesModal";
import { LeadProvider, useLeads } from "@/pages/leads/context/leadContext";
import { formataDate, formatInDate } from "@/utils/formatDate";
import { FormatNameSize } from "@/utils/FormatNameSize";
import { ModalDelete } from "@/components/ModalDelete";
import UserService from "@/services/UserService";
import attendanceApi from "@/services/api/attendance";
import briefingApi from "@/services/api/briefing";
import { useNavigate } from "react-router-dom";
import { CustomSnackbar } from "@/utils/alert";
import clientApi from "@/services/api/client";
import { leadApi } from "@/services/api/leads";
import { LeadStageEnum } from "@/interfaces/RegisterLead";
import { AtendimentoStateEnum } from "@/interfaces/AttendanceData";
import { EstadoAtendimento } from "@/interfaces/AttendanceData";
import { ArrowRight, ArrowRightAlt, PanoramaFishEye, RemoveRedEye } from "@mui/icons-material";
import { ClientContextProvider, useClient } from "@/contexts/ClientContext";
import { previousMonday } from "date-fns";
import { KanbanCardSkeleton } from "../KanbanCardSkeleton";

interface Lead {
  titulo?: string;
  id: number;
  nome: string;
  telefone: string;
  criadoEm: string;
  estagioAtualizadoEm: string;
  origem: string;
  Atendente: {
    nome: string;
  };
  attendanceState? : string;
  cliente_id?: number;
}
interface SelectButtonRef {
  clearSelection: () => void;
}

type Severity = "success" | "error";
interface UserCardInterface {
  lead: Lead;
  columnTitle: string; 
  ref_: React.RefObject<HTMLDivElement> | null;
  carregando: boolean;
}



export function KanbanCardComponent({ lead, columnTitle, ref_: ref, carregando }: UserCardInterface) {


  const useAttendants = () => {
    const [attendantOption, setAttendantOption] = useState<Atendente[]>([]);
    const { setError } = useLeads();

    useEffect(() => {

      const fetchAttendants = async () => {
        try {
          const response = await attendantApi.getAttendants();
          const attendants = response.data.map((attendant: Atendente) => ({
            id: attendant.id,
            nome: attendant.nome,
          }));
          setAttendantOption(attendants);
        } catch (error) {
          setError(error as Error);
        } finally {
        }
      };

      fetchAttendants();
    }, [setError]);

    return attendantOption;
  };

  const { handleDelete, setLeads} = useLeads();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [moveAnchorEl, setMoveAnchorEl] = useState<null | HTMLElement>(null);
  const [openDetails, setOpenDetails] = useState(false);
  const [selectedLead, setSelectedLead] = useState<Lead | null>(null);
  const attendantOption = useAttendants();
  const open = Boolean(anchorEl);
  const [openConfirm, setOpenConfirm] = useState(false);
  const { nome, telefone, criadoEm, estagioAtualizadoEm, origem, Atendente } = lead;
  const selectButtonRef = useRef<SelectButtonRef>(null);
  const [showAlert, setShowAlert] = useState(false);
  const [alertInfo, setAlertInfo] = useState({
    severity: "success" as Severity,
    message: "",
  });
  const navigate = useNavigate();
  const { setReloadList } = useLeads();
    
  const clienteContext = useClient();

  const initialColumns = [ 
    { id: "column-1", title: "Não classificado", value: LeadStageEnum.NAO_CLASSIFICADO },
    { id: "column-2", title: "Perdido", value: LeadStageEnum.PERDIDO },
    { id: "column-3", title: "Em contato", value: LeadStageEnum.EM_CONTATO },
    { id: "column-4", title: "Briefing", value:  AtendimentoStateEnum.BRIEFING, isAtendimento: true},
    { id: "column-5", title: "Em negociação", value: AtendimentoStateEnum.NEGOCIACAO, isAtendimento: true },
    { id: "column-6", title: "Pagamento realizado", value: AtendimentoStateEnum.PAGAMENTO_REALIZADO, isAtendimento: true },
    { id: "column-7", title: "Conferência de medidas", value: AtendimentoStateEnum.CONFERENCIA_MEDIDAS, isAtendimento: true },
    { id: "column-8", title: "Projeto técnico", value: AtendimentoStateEnum.PROJETO_TECNICO, isAtendimento: true },
    { id: "column-9", title: "Em produção", value: AtendimentoStateEnum.PRODUCAO, isAtendimento: true },
    { id: "column-10", title: "Agendar montagem", value: AtendimentoStateEnum.AGENDAR_MONTAGEM, isAtendimento: true },
    { id: "column-11", title: "Realizou montagem", value: AtendimentoStateEnum.REALIZOU_MONTAGEM, isAtendimento: true },
    { id: "column-12", title: "Obter feedback", value: AtendimentoStateEnum.FEEDBACK, isAtendimento: true },
    { id: "column-13", title: "Venda Concluída", value: AtendimentoStateEnum.POS_VENDA, isAtendimento: true },
  ];

  const handleOpenMoveMenu = (event: React.MouseEvent<HTMLElement>) => {
    const availableOptions = initialColumns
      .map((column) => column.title)
      .filter((stage) => stage !== columnTitle);
    setMoveAnchorEl(event.currentTarget);
  };

  const handleMoveLead = async (newStage: string, isAtendimento : boolean) => {
    try {

      if(isAtendimento){
        await attendanceApi.updateAttendanceKanban(lead.id, newStage as AtendimentoStateEnum, {estado : lead.attendanceState} as EstadoAtendimento);
      }

      else{
        await leadApi.updateLead(lead.id, { stage: newStage });
      }

      setLeads((prevLeads) =>
        prevLeads.map((l) => (l.id === lead.id ? { ...l, stage: newStage } : l))
      );
      setReloadList(true); // Dispara a atualização do Kanban no nível superior
    } catch (error) {
      console.error("Erro ao mover lead:", error);
    }
    setMoveAnchorEl(null); // Fechar o menu
  };
  
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setMoveAnchorEl(null);
  };

  function handleAlertClose() {
    setShowAlert(false);
  }

  const handleOpenModalDetails = () => {
    setSelectedLead(lead);
    setOpenDetails(true);
  };

  const handleCloseModalDetails = () => {
    setOpenDetails(false);
    setSelectedLead(null);
  };


  if (carregando) {
    return (
      <div className={style.spinnerContainer}>
        <KanbanCardSkeleton/>
      </div>
    );
  }

  const cardSections = [
    {
      leftText: "Criado em",
      rightText: formatInDate(criadoEm),
      leftClass: style.cardBodyLeft,
      rightClass: style.cardBodyHeigth,
    },
    {
      leftText: "Origem",
      rightText: origem,
      leftClass: style.cardBodyLeft,
      rightClass: style.cardBodyHeigth,
    },
    {
      leftText: "Atendente",
      rightText: <strong>{Atendente?.nome || "Sem atendente"}</strong>,
      leftClass: style.cardBodyLeft,
      rightClass: style.footerRigth,
    },
    {
      leftText: "Atendimento",
      rightText: lead.titulo || `Atendimento para ${lead.nome}`,
      leftClass: style.cardBodyLeft,
      rightClass: style.footerRigth,
    },
  ];

  function handleOpenModalConfirm(id: number) {
    setOpenConfirm(true); // E abre o modal de confirmação
  }

  function handleCloseModal() {
    setOpenConfirm(false);
    if (selectButtonRef.current) {
      selectButtonRef.current.clearSelection(); // Chama a função para limpar a seleção
    }
  }

  
  async function handleCreateAtendimento(lead: any) {
    let clientId;
  
    try {
      if (!lead.telefone) {
        console.error(`Lead com ID ${lead.id} não possui um número de telefone`);
        return;
      }
  
      // 1. Verificar se o cliente já existe pelo telefone
      const findResponse = await clientApi.findByPhone(lead.telefone);
      if (findResponse.status === 200 && findResponse.data) {
        // Cliente existe, pegar o ID
        clientId = findResponse.data.id;
      }
  
      // (OUTDATED) 2. Atualizar o estágio do lead para "Briefing" se o cliente foi encontrado
      if (clientId) {
        // await updateEtapa(lead.id, "Briefing", true);
  
        // 3. Criar atendimento com o ID do cliente existente
        await createAttendance(clientId);
  
        return; // Saímos da função após criar o atendimento com sucesso
      }
    } catch (err) {
   
        try {
          // Criar um novo cliente, já que não foi encontrado
          const newClientData = {
            dataClient: {
              nome: lead.nome,
              telefone: lead.telefone,
              email: null,
              cpf: "",
            },
            dataAddress: null,
            dataDeliveryAddress: null,
          };
  
          const createResponse = await clientApi.create(newClientData);
          if (createResponse.status !== 201 && createResponse.status !== 200) {
            throw new Error("Erro ao criar o cliente");
          }
  
          clientId = createResponse.data.response.client.id;
  
          // Atualizar o estágio do lead para "Briefing"
          await updateEtapa(lead.id, "Briefing", true);
  
          // Criar atendimento com o ID do cliente recém-criado
          await createAttendance(clientId);
  
        } catch (creationError) {
          console.error("Erro ao criar o cliente ou atendimento:", creationError);
          setAlertInfo({
            severity: "error",
            message: "Erro ao criar o cliente e atendimento.",
          });
          setShowAlert(true);
        }
    }
  }
  
  // Função de criar o atendimento
  const createAttendance = async (clientId: number) => {
    try {
      const userId = UserService.getUser()?.userId;
      if (!userId) throw new Error("Não há informação de userId");
  
      const attendantResponse = await attendantApi.getAttendantByUserId(userId);
      if (attendantResponse.status === 500) throw new Error("Erro ao recuperar atendente");
  
      const attendant = attendantResponse.data;
      if (!attendant)
        throw new Error("Erro ao recuperar dados do atendente, atendente provavelmente não existe com este id");
  
      const attendanceResponse = await attendanceApi.createAttendance(clientId, attendant.id);
      if (attendanceResponse.status === 500)
        throw new Error("Erro ao criar atendimento");
  
      const attendanceId = attendanceResponse.data.id;
  
      const briefingResponse = await briefingApi.createBriefing(attendanceId);
      if (briefingResponse.status === 500 || !briefingResponse.data)
        throw new Error("Erro ao criar briefing");
  
      setAlertInfo({
        severity: "success",
        message: "Atendimento criado com sucesso! Redirecionando para atendimentos...",
      });
      setShowAlert(true);
      setTimeout(() => {
        setShowAlert(false);
        navigate(`/homepage?cliente=${clientId}`);
      }, 2000);
    } catch (error) {
      console.error("Erro ao criar atendimento e briefing:", error);
    }
  };
  
  async function updateEtapa(id: number, stage: string, isAtendimento : boolean) {
    const data = { stage };

    if(isAtendimento){
      const response = await attendanceApi.updateAttendanceKanban(id, stage as AtendimentoStateEnum, {estado : lead.attendanceState} as EstadoAtendimento);
      if (response.status === 200) {
        setLeads((prevLeads) =>
          prevLeads.map((lead) => (lead.id === id ? { ...lead, stage } : lead))
        );
      } else if (response.status === 404) {
        console.error("Atendimento não encontrado");
      }
    }

    else{
      const response = await leadApi.updateLead(id, data);
    
      if (response.status === 200) {
        setLeads((prevLeads) =>
          prevLeads.map((lead) => (lead.id === id ? { ...lead, stage } : lead))
        );
      } else if (response.status === 404) {
        console.error("Lead não encontrado");
      }
    }

  }


  return (
    <Box className={style.card} ref={ref} style={{padding:"40px"}}>
      {/* Submenu de Mover Lead */}
        <Menu
          anchorEl={moveAnchorEl}
          open={Boolean(moveAnchorEl)}
          onClose={handleClose}
        >

          {
            //garantindo que iremos mostrar apenas a opção de mover para a direita (proximo estagio)
            //apenas quando for um estagio de atendimento (maior que 2 e dps de pos venda (o ultimo) não tem mais estagios)
            initialColumns.findIndex((column) => column.title === columnTitle) < initialColumns.length - 1 &&
            initialColumns.findIndex((column) => column.title === columnTitle) > 2?
              (() => {

                //buscando indice do estagio atual
                const currentIndex = initialColumns.findIndex((column) => column.title === columnTitle);

                //buscando o proximo estagio
                const nextColumn = initialColumns[currentIndex + 1];

                return (
                  <MenuItem
                    key={columnTitle}
                    onClick={() => handleMoveLead(nextColumn.value, nextColumn.isAtendimento ?? false)}
                  >
                    {nextColumn.title}
                    <ArrowRightAlt/>
                  </MenuItem>
                );
              })()
              : //caso o estagio seja de lead, mostramos apenas as opções de lead, permitindo mover livremente
              initialColumns
                .filter((column) => (column.title !== columnTitle && initialColumns.findIndex((c) => c.title == column.title)  < 3))
                .map((column) => (
                  <MenuItem
                    key={column.title}
                    onClick={() => handleMoveLead(column.value, column.isAtendimento ?? false)}
                  >
                    {column.title}
                  </MenuItem>
                ))
          }
        </Menu>
      <CustomSnackbar
        open={showAlert}
        severity={alertInfo.severity}
        message={alertInfo.message}
        handleClose={handleAlertClose}
      />
      <Box className={style.iconRigth}>
        <IconButton
          aria-label="more options"
          aria-controls="lead-menu"
          aria-haspopup="true"
          onClick={handleClick}
          className={style.buttonIcon}
        >
          <MoreVertIcon />
        </IconButton>
        <Menu
          id="lead-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          PaperProps={{
            style: {
              maxHeight: 48 * 4.5,
              width: "23ch",
            },
          }}
        >
          {
            //mostrando menu para mover atendimento e lead
            //exceto para o ultimo estagio de atendimento (pos venda)
            initialColumns.findIndex((column) => column.title === columnTitle) < initialColumns.length - 1 &&
              <MenuItem
                onClick={handleOpenMoveMenu}
                className={style.options}
              >
                <SwapHorizIcon />
                Mover
                {
                  lead.attendanceState ? " atendimento" : " lead"
                }
              </MenuItem>
          }
          <MenuItem onClick={handleOpenModalDetails} className={style.options}>
            <ReplayIcon />
            Detalhes
          </MenuItem>
          {["Não classificado", "Em contato"].includes(columnTitle) ? ( // Usando o colchetes para verificar se o valor está dentro do array columnTitle
            <MenuItem onClick={()=> {
              handleCreateAtendimento(lead);}

            } className={style.options}> 
              <AddIcon />
              Criar Atendimento
            </MenuItem>
          ) : !["Perdido"].includes(columnTitle) && (
            <MenuItem
              onClick={() => {
                console.log("lead", lead)
                let tmpClient = clienteContext.client;
                tmpClient.atendimentoAtualId = lead.id
                clienteContext.setClient(tmpClient)
                console.log("kanban tmpClient", tmpClient)
                // clienteContext.setClient({...clienteContext.client, atendimentoAtualId : lead.id})
                navigate("/homepage?cliente="+ lead.cliente_id+"&atendimentoId="+lead.id);
              }}
              className={style.options}
            >
              <RemoveRedEye />
              Visualizar atendimento
            </MenuItem>
          )}
          {
            !lead.attendanceState && 
            <MenuItem
              onClick={() => handleOpenModalConfirm(lead.id)}
              className={style.options}
            >
              <DeleteOutlineOutlinedIcon /> Apagar
            </MenuItem>
          }
        </Menu>
      </Box>
      <Box className={style.cardHeader}>
        <Box className={style.cardHeaderLeft}>
          <Avatar className="list-item-avatar">
            <Typography variant="h5">{nome?.charAt(0)}</Typography>
          </Avatar>
        </Box>
        <Box className={style.cardHeaderHeigth}>
          <Typography className={style.name}>
            {FormatNameSize(nome, 20)}
          </Typography>
          <Typography className={style.phone}>{telefone}</Typography>
        </Box>
      </Box>

      {
      cardSections.map((section, index) => (
        //Removendo campo Origem de atendimentos
        //Atendimento não tem informação de origem
        
        section.leftText == "Origem" && lead.attendanceState ? <></> :
        section.leftText == "Atendimento" && !lead.attendanceState ? <></> :
        <Box className={style.cardBody} key={index}>
          <Box className={section.leftClass} style={{marginRight:"20px"}}>
            <Typography className={style.data}>{section.leftText}</Typography>
          </Box>
          <Box className={section.rightClass} style={{marginLeft:"5px"}}>
            <Typography className={style.data} style={{marginLeft:"10px"}}>{section.rightText}</Typography>
          </Box>
        </Box>
      ))}

      <Box className={style.cardFooter} style={{}}>
        <Typography className={style.footerLeft}>
          {formataDate(estagioAtualizadoEm.toString()).display
          }
        </Typography>
      </Box>

      <DetalhesModal
        open={openDetails}
        close={handleCloseModalDetails}
        AttendantOption={attendantOption}
        selectedLead={selectedLead}
        local={"Kanban"}
      />
      <ModalDelete
        open={openConfirm}
        onClose={handleCloseModal} 
        onDelete={() => handleDelete(lead.id)} // Chama a função handleDelete ao confirmar
      />
    </Box>
  );
}

// ===========
// deprecated
// ===========
// export function KanbanCard({ lead, columnTitle }: UserCardInterface) {
//   return (
//     <LeadProvider>
//       <KanbanCardComponent lead={lead} columnTitle={columnTitle}/>
//     </LeadProvider>
//   );
// }
